import Link from 'next/link'
import styled from 'styled-components'

import { Button } from '@/components/elements/Button'
// import { NewsItem } from '@/components/elements/News/NewsItem'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'

import { NewsRelease as NewsReleaseType } from '@/types/newsRelease'

type Props = {
  newsList: readonly NewsReleaseType[]
}

export const NewsRelease = ({ newsList }: Props) => {
  return (
    <div>
      <SectionTitle
        titleText="News Release"
        subTitleText=""
        color="normal"
      />
      <Spacer h={{ sp: 40, pc: 50 }} />
      <NewsList>
        {/* {newsList.map(({ _id, tag, title, publishDate }, index) => (
          <NewsItem
            key={_id}
            link={`/news/release/${_id}`}
            title={title}
            publishDate={publishDate}
            tag={tag}
            isNotShowBottom={index === 2}
          />
        ))} */}
      </NewsList>
      <EnNewslist>
        <div>
          <p>2023/12/28</p>
          <Link href="/en/news/ennews">
            <a>Establishment of The English Version of The Website</a>
          </Link>
        </div>
      </EnNewslist>
      <Spacer h={{ sp: 40, pc: 60 }} />
      <MoreButtonWrapper>
        <Link href="/en/news/release" passHref>
          <a>
            <Button btnStyle="transparent">More</Button>
          </a>
        </Link>
      </MoreButtonWrapper>
    </div>
  )
}

const NewsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const MoreButtonWrapper = styled.div`
  margin-top: 38px;
  display: flex;
  justify-content: center;

  @media screen and (max-width: 1047px) {
    margin-top: 40px;
  }
`
const EnNewslist = styled.div`
div {
  display: flex;
  align-items: center;
}

p {
  margin-right: 40px;
  margin-left: 30px
}

a:hover {
  text-decoration: underline;
}
`